import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { agenciesReducer as agencies } from './agencies';
import { calendarsReducer as calendars } from './calendars';
import { routesReducer as routes } from './routes';
import { stopsReducer as stops } from './stops';
import { stopTimesReducer as stoptimes } from './stoptimes';
import { timetableReducer as timetable } from './timetable';
import { sfaxTripsReducer as sfaxTrips } from './sfaxTrips';
import { kerkenahTripsReducer as kerkenahTrips } from './kerkenahTrips';

import { tripsReducer as trips } from './trips';
import { usersReducer as users } from './users';
import { vehiclesReducer as vehicles } from './vehicles';
import { errorsReducer as errors } from './errors';
import { sessionReducer as session } from './session';

import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';

import storage from 'redux-persist/lib/storage';

const reducer = combineReducers({
  session,
  agencies,
  calendars,
  routes,
  stops,
  stoptimes,
  timetable,
  trips,
  users,
  vehicles,
  errors,
  sfaxTrips,
  kerkenahTrips
});

export { agenciesActions } from './agencies';
export { calendarsActions } from './calendars';
export { routesActions } from './routes';
export { stopsActions } from './stops';
export { stopTimesActions } from './stoptimes';
export { timetableActions } from './timetable';
export { tripsActions } from './trips';
export { usersActions } from './users';
export { vehiclesActions } from './vehicles';
export { errorsActions } from './errors';
export { sessionActions } from './session';
export { sfaxTripsActions } from './sfaxTrips';
export { kerkenahTripsActions } from './kerkenahTrips';




const persistConfig = {
  key: 'root',
  storage: storage,
};

const persistedReducer = persistReducer(persistConfig, reducer);

//export const store = createStore(persistedReducer);
//export const persistor = persistStore(store);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
export const persistor = persistStore(store);
